module.exports = __webpack_public_path__ + "images/blank-content/events-blank-3a7de553aab400eca1776078b061d0c8.png";